// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1FIqX","header":"ClearentDisclaimer_header__2QTcE","inner":"ClearentDisclaimer_inner__8fU1s"};